import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-mustache",
  "use": "icon-si-glyph-mustache-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-mustache\" id=\"icon-si-glyph-mustache\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1123</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.907,7.514 C15.346,9.152 14.16,8.704 12.213,6.885 C10.602,5.382 9.279,6.305 8.959,7.6 C8.635,6.303 7.311,5.382 5.701,6.888 C3.758,8.709 2.572,9.159 1.01,7.524 C0.855,9.17 2.524,10.712 4.735,10.965 C6.784,11.199 8.581,10.246 8.96,8.797 C9.343,10.248 11.139,11.198 13.189,10.96 C15.398,10.703 17.064,9.161 16.907,7.514 L16.907,7.514 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-mustache.svg
// module id = r1ht
// module chunks = 62